// src/components/Login.jsx
import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import LoaderModal from "./LoaderModal";
import { useLanguage } from "../context/LanguageContext";
import LanguageSwitcher from "./LanguageSwitcher";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const { login } = useAuth();
  const { language } = useLanguage();
  const isFr = language === "fr";
  const t = (frText, enText) => (isFr ? frText : enText);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(email, password);
      navigate("/", { replace: true });
    } catch (err) {
      console.log(err);
      setError(t("Échec de la connexion. Vérifiez votre e-mail et votre mot de passe.", "Sign-in failed. Check your email and password."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative flex min-h-screen items-center justify-center bg-slate-950 bg-mesh-gradient px-4 py-16">
      {loading ? <LoaderModal /> : null}
      <div className="pointer-events-none absolute inset-0 bg-[linear-gradient(to_bottom,transparent,rgba(2,6,23,0.9))]" />
      <form
        onSubmit={handleSubmit}
        className="relative ui-panel w-full max-w-md space-y-5 p-8 sm:p-10"
      >
        <div className="text-center">
          <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br from-brand-500 to-indigo-600 text-sm font-bold text-white shadow-glow">
            AT
          </div>
          <h1 className="text-2xl font-bold tracking-tight text-white">{t("Se connecter", "Sign in")}</h1>
          <p className="mt-2 text-sm text-slate-500">{t("Accédez aux préférences enregistrées et aux filtres de langue.", "Access saved preferences and language filters.")}</p>
          <div className="mt-3 flex justify-center">
            <LanguageSwitcher />
          </div>
        </div>
        {error ? (
          <p className="rounded-lg border border-rose-900/50 bg-rose-950/30 px-3 py-2 text-sm text-rose-200">{error}</p>
        ) : null}
        <div className="space-y-2">
          <label htmlFor="login-email" className="text-xs font-medium text-slate-400">
            {t("E-mail", "Email")}
          </label>
          <input
            id="login-email"
            type="email"
            autoComplete="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="ui-input"
            placeholder="you@example.com"
          />
        </div>
        <div className="space-y-2">
          <label htmlFor="login-password" className="text-xs font-medium text-slate-400">
            {t("Mot de passe", "Password")}
          </label>
          <input
            id="login-password"
            type="password"
            autoComplete="current-password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="ui-input"
            placeholder="••••••••"
          />
        </div>
        <button type="submit" className="ui-btn-primary w-full py-3 text-base" disabled={loading}>
          {t("Continuer", "Continue")}
        </button>
        <p className="text-center text-sm text-slate-500">
          {t("Pas de compte ?", "No account?")}{" "}
          <Link to="/signup" className="font-medium text-brand-400 hover:text-brand-300">
            {t("Créer un compte", "Create one")}
          </Link>
        </p>
      </form>
    </div>
  );
}
